import { css } from 'styled-components';

var breakpoints = {
  s: 768,
  m: 1024,
  l: 1280
};
var mq = {
  s: function s(styles) {
    return css(["@media (min-width:", "px){", ";}"], breakpoints.s, styles);
  },
  sMax: function sMax(styles) {
    return css(["@media (max-width:", "px){", ";}"], breakpoints.s - 1, styles);
  },
  m: function m(styles) {
    return css(["@media (min-width:", "px){", ";}"], breakpoints.m, styles);
  },
  mMax: function mMax(styles) {
    return css(["@media (max-width:", "px){", ";}"], breakpoints.m - 1, styles);
  },
  l: function l(styles) {
    return css(["@media (min-width:", "px){", ";}"], breakpoints.l, styles);
  },
  lMax: function lMax(styles) {
    return css(["@media (max-width:", "px){", ";}"], breakpoints.l - 1, styles);
  },
  retina: function retina(styles) {
    return css(["@media (min-resolution:192dpi){", ";}"], styles);
  }
};
var mq$1 = mq;

export { mq$1 as default };
//# sourceMappingURL=mediaQueries.js.map
